/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';
import Link from 'next/link';
import { Button, Text } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { useImagePreload } from '@/hooks/ImagePreloader';
import { classnames } from '@/utils/classnames';
import { IStorySlide } from '../Story.type';
import LazyImage from '../../LazyImage';

export interface IStorySlideProps
  extends Pick<IStorySlide, 'buttonLink' | 'buttonText' | 'id' | 'url'> {
  title?: string;
  avatarUrl?: string;
  url: string;
  isPaused: boolean;
  onClose?: () => void;
}

const StorySlide: FC<IStorySlideProps> = ({
  id,
  title,
  url = '',
  avatarUrl,
  isPaused,
  buttonLink,
  buttonText,
  onClose,
}) => {
  const { isError } = useImagePreload(url);

  const renderContent = () => {
    if (isError) {
      return (
        <div className="flex h-full w-full items-center justify-center bg-white">
          <Text color="red-50" size={16} weight="bold">
            خطا در دریافت اطلاعات
          </Text>
        </div>
      );
    }

    return (
      <div
        className="relative h-full w-full"
        style={{
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundImage: `url(${url})`,
        }}
      >
        {buttonText && buttonLink ? (
          <Link
            className="absolute bottom-4 z-[1000] flex w-full items-center justify-center p-5"
            href={buttonLink}
            onClick={onClose}
          >
            <Button className="w-full">
              <Text size={14} weight={500}>
                {buttonText}
              </Text>
            </Button>
          </Link>
        ) : null}
      </div>
    );
  };

  return (
    <div className="h-full w-full" id={id}>
      <header
        className={classnames(
          'absolute top-0 z-[1000] mt-6 flex w-full flex-row items-center justify-between px-7',
          {
            'opacity-0 transition-opacity delay-200': isPaused,
          }
        )}
      >
        <div className="flex flex-row items-center gap-2">
          {avatarUrl ? (
            <LazyImage
              alt=""
              className="h-8 w-8 rounded-lg bg-gray-filledinvert-primary-enabled"
              src={avatarUrl}
            />
          ) : null}
          <Text color="gray-110" size={12} weight={600}>
            {title}
          </Text>
        </div>

        <div>
          {onClose ? (
            <button
              className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-filledinvert-primary-enabled"
              onClick={onClose}
            >
              <Icon color="green-30" icon="close" size={20} />
            </button>
          ) : null}
        </div>
      </header>

      {renderContent()}
    </div>
  );
};

export default StorySlide;
